import { Show } from "solid-js";
import Text from "../../text/Text";
import { isNil } from "lodash-es";
import type { ImageOption, ListItemHtmlProps } from "../../../types/Menu";
import SelectImage from "../SelectImage";
import ListItemContainer from "./ListItemContainer";

type ImageListItemProps = Omit<ImageOption<null>, "variant" | "value"> & {
  htmlProps: ListItemHtmlProps;
};

const ImageListItem = (props: ImageListItemProps) => (
  <ListItemContainer htmlProps={props.htmlProps} disabled={props.disabled} hidden={props.hidden} type="row">
    <SelectImage {...props.image} size="md" />
    <div class="flex min-w-0 flex-col">
      <Text
        as="span"
        truncate
        text={props.label}
        class="text-primary group-disabled:text-disabled"
        classList={{
          "text-base-regular": isNil(props.description),
          "text-base-medium": !isNil(props.description),
        }}
      />
      <Show when={props.description}>
        {(description) => (
          <Text
            as="span"
            truncate={2}
            text={description()}
            class="text-base-regular text-secondary group-disabled:text-disabled"
            classList={{ "group-aria-selected:text-primary group-selected:text-primary": props.disabled !== true }}
          />
        )}
      </Show>
    </div>
  </ListItemContainer>
);

export default ImageListItem;
